import classNames from 'classnames';
import { HTMLAttributes, memo } from 'react';

const COLORS_MAP = {
  blueLightest: 'border-blueLightest',
  blackLight: 'border-charcoal-100',
  blackLighter: 'border-charcoal-50',
  white: 'border-white',
  glooNavyLight: 'border-glooNavy-100',
  glooGrayBorder: 'border-glooGrayBorder',
};

export interface SeparatorProps extends HTMLAttributes<HTMLDivElement> {
  color?: keyof typeof COLORS_MAP;
  large?: boolean;
}

const Separator = memo(({ className, color, large, ...rest }: SeparatorProps) => {
  return (
    <div
      className={classNames(
        `border-t w-full`,
        { 'border-t-2': large },
        className,
        color ? COLORS_MAP[color] : COLORS_MAP.blackLight,
      )}
      {...rest}
    />
  );
});

Separator.displayName = 'Separator';

export default Separator;
